import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { BaseModule, Image, generateCuts, parseCutsObj } from '@yes/components';

const MAX_STORIES_COUNT = 3;

class MoreVideosModule extends Component {
    constructor(props) {
        super(props);

        this.renderList = this.renderList.bind(this);
    }

    renderList() {
        const { items } = this.props;

        return items.slice(0, MAX_STORIES_COUNT).map((item) => {
            const { slug, title, contentDate, thumbnail = {} } = item;
            const srcSetSquare = generateCuts(thumbnail.templateUrl, 'jpg', '1:1');
            const srcSetRect = generateCuts(thumbnail.templateUrl, 'jpg', '16:9');

            return (
                <a className="module__item" href={`/video/${slug}`} key={slug}>
                    <div className="module__item--content">
                        <span className="module__item--title">{title}</span>
                        <span className="module__item--subtitle">{moment(contentDate).format('MMMM D, YYYY')}</span>
                    </div>
                    <Image
                        className="module__item--thumbnail-square"
                        srcSet={parseCutsObj(srcSetSquare)}
                        alt={thumbnail.title}
                        title={thumbnail.title}
                    />
                    <Image
                        className="module__item--thumbnail-rect"
                        srcSet={parseCutsObj(srcSetRect)}
                        alt={thumbnail.title}
                        title={thumbnail.title}
                    />
                </a>
            );
        });
    }

    render() {
        const { slug, title, items } = this.props;
        if (!items.length) {
            return null;
        }
        const headerText = title === 'Top Videos' ? `Latest ${title}` : `Latest ${title} Videos`;
        const footerText = title === 'Top Videos' ? `All ${title}` : `All ${title} Videos`;
        return (
            <BaseModule
                extraClass="module__more-videos"
                headerContent={<h5 className="module__header--title">{headerText}</h5>}
                bodyContent={<div className="module__item-container">{this.renderList()}</div>}
                footerContent={
                    <a href={`/video/topic/${slug}`} className="module__item--title">
                        {footerText} &rarr;
                    </a>
                }
            />
        );
    }
}

MoreVideosModule.propTypes = {
    advancedCriteria: PropTypes.string,
    headline: PropTypes.string,
    items: PropTypes.array,
    slug: PropTypes.string,
    title: PropTypes.string,
    topicPageType: PropTypes.string
};

MoreVideosModule.defaultProps = {};

export default MoreVideosModule;
